<template>
    <div>
        <AlertModalWindow v-if="deleteKassaRequirementIsOpened" v-model:isOpened="deleteKassaRequirementIsOpened" title="Необходимо удалить кассы" description="У вас больше касс, чем доступно в выбранном тарифе. Пожалуйста, перед переходом на этот тариф удалите все лишние кассы" />
        <div class="rounded-md bg-white h-full p-6">
            <div class="flex flex-col items-stretch justify-between h-full gap-8">
                <div class="grid grid-cols-1 gap-4">
                    <p class="flex items-center gap-4">
                        <span class="text-lg font-semibold">{{ labels.plans[name] }}</span>
                        <svg v-if="isActive" class="w-6 h-6 text-custom-blue" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q65 0 123 19t107 53l-58 59q-38-24-81-37.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160q133 0 226.5-93.5T800-480q0-18-2-36t-6-35l65-65q11 32 17 66t6 70q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm-56-216L254-466l56-56 114 114 400-401 56 56-456 457Z"/></svg>
                    </p>
                    <p class="text-sm text-gray-600">{{ description }}</p>

                    <div class="grid grid-cols-1 gap-2">
                        <p v-for="feature in features" :key="feature" class="flex items-center gap-1">
                            <svg class="h-6 w-5 flex-none text-indigo-600" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clip-rule="evenodd"></path></svg>
                            <span class="text-sm text-gray-600">{{ feature }}</span>
                        </p>
                        <div v-if="name !== 'free'" class="flex items-center gap-2 text-sm text-gray-600">
                            <svg class="h-6 w-5 flex-none text-indigo-600" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clip-rule="evenodd"></path></svg>
                            <p class="whitespace-nowrap mr-2">Количество касс: </p>
                            <input type="number" v-model="amountKassas" min="1" @input="handleInputAmountKassas" class="h-[24px] w-[4.5rem] p-2 text-sm text-gray-900 rounded border border-custom-blue focus:ring-blue-500 focus:border-blue-500 flex justify-between items-center">
                        </div>
                        <div v-else class="flex items-center gap-2 text-sm text-gray-600">
                            <svg class="h-6 w-5 flex-none text-indigo-600" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clip-rule="evenodd"></path></svg>
                            <p class="whitespace-nowrap mr-2">Количество касс: </p>
                            <span>1</span>
                        </div>
                    </div>
                </div>

                <div class="grid grid-cols-1 gap-4">
                    <div v-if="name === 'free'">
                        <p class="font-semibold text-xl mb-4">Бесплатно</p>
                    </div>
                    <div v-else>
                        <div v-if="name === 'monthly'" class="mb-2">
                            <p v-if="promoCodeDiscount === 0" class="font-semibold text-xl">{{ `${this.$globalMethods.formatNumberWithSpaces(currentPricePerMonth)}₽/мес` }}</p>
                            <div v-else class="font-semibold">
                                <p class="line-through">{{ `${this.$globalMethods.formatNumberWithSpaces(currentPricePerMonth)}₽/мес` }}</p>
                                <p>
                                    <span class="text-xl mr-2">{{ `${this.$globalMethods.formatNumberWithSpaces(currentPricePerMonthWithDiscount)}₽/мес` }}</span>
                                    <span>{{`(скидка ${this.promoCodeDiscount}%)`}}</span>
                                </p>
                            </div>
                        </div>
                        <div v-else-if="name === 'annual'" class="mb-2">
                            <p v-if="promoCodeDiscount === 0" class="font-semibold text-xl flex items-center gap-2">
                                <span>{{ `${this.$globalMethods.formatNumberWithSpaces(currentPricePerYear)}₽/год` }}</span>
                                <span>|</span>
                                <span>{{ `${this.$globalMethods.formatNumberWithSpaces(currentPricePerMonth)}₽/мес` }}</span>
                            </p>
                            <div v-else class="font-semibold">
                                <p class="line-through flex items-center gap-2">
                                    <span>{{ `${this.$globalMethods.formatNumberWithSpaces(currentPricePerYear)}₽/год` }}</span>
                                    <span>|</span>
                                    <span>{{ `${this.$globalMethods.formatNumberWithSpaces(currentPricePerMonth)}₽/мес` }}</span>
                                </p>
                                <p class="flex items-start flex-col">
                                    <span class="text-xl flex items-center gap-2">
                                        <span>{{ `${this.$globalMethods.formatNumberWithSpaces(currentPricePerYearWithDiscount)}₽/год` }}</span>
                                        <span>|</span>
                                        <span>{{ `${this.$globalMethods.formatNumberWithSpaces(currentPricePerMonthWithDiscount)}₽/мес` }}</span>
                                    </span>
                                    <span>{{`(скидка ${this.promoCodeDiscount}%)`}}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div v-if="name !== 'free' && profileData.promo_code === null" class="flex items-center justify-between gap-4 mb-4">
                        <span class="text-sm text-gray-600 text-nowrap">У меня есть промо-код</span>
                        <input type="text" v-model="promoCode" @input="handlePromoCodeInput" class="min-w-0 w-full p-2 text-sm text-gray-900 rounded border border-custom-blue focus:ring-blue-500 focus:border-blue-500 flex justify-between items-center">
                        <svg v-if="promoCodeIsActive" class="w-6 h-6 cursor-pointer text-green-600 shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
                        <button v-else @click="checkPromoCode" type="button" class="border border-custom-blue bg-custom-blue hover:bg-custom-blue-hover flex items-center text-white font-medium rounded-lg text-sm px-5 py-2 whitespace-nowrap">применить</button>
                    </div>
                    <button @click="selectPlan" :disabled="isActive && currentAmountOfShops === amountKassas" :class="isActive && currentAmountOfShops === amountKassas ? '' : 'hover:bg-[#187068]'" class="border border-[#0E998D] bg-[#0E998D] text-center text-white font-medium rounded-lg text-sm px-5 py-2 whitespace-nowrap">{{ isActive && currentAmountOfShops === amountKassas ? 'Ваш текущий тариф' : 'Подключить' }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    import AlertModalWindow from '@/components/modal/AlertModalWindow.vue';

    export default {
        name: "PricingCard",
        components: {
            AlertModalWindow
        },
        props: {
            isActive: {
                type: Boolean,
                default: false,
            },
            isOneOff: {
                type: Boolean,
                required: true,
            },
            currentAmountOfShops: {
                type: [Number, null],
                required: false,
            },
            description: {
                type: String,
                required: true,
            },
            name: {
                type: String,
                required: true,
            },
            pricePerMonth: {
                type: [String, Number, null],
                required: false,
            },
            pricePerYear: {
                type: [String, Number, null],
                required: false,
            },
            priceByAdditionalShopPerYear: {
                type: [String, Number, null],
                required: false,
            },
            priceByAdditionalShopPerMonth: {
                type: [String, Number, null],
                required: false,
            },
            features: {
                type: Array,
                required: true,
            }
        },
        computed: {
            ...mapState(["kassas", "labels", "profileData"]),
            currentPricePerMonth() {
                return Number(this.pricePerMonth) + ((this.amountKassas - 1) * Number(this.priceByAdditionalShopPerMonth));
            },
            currentPricePerMonthWithDiscount() {
                return (this.currentPricePerMonth * (1 - this.promoCodeDiscount / 100)).toFixed(2);
            },
            currentPricePerYear() {
                return Number(this.pricePerYear) + ((this.amountKassas - 1) * Number(this.priceByAdditionalShopPerYear));
            },
            currentPricePerYearWithDiscount() {
                return (this.currentPricePerYear * (1 - this.promoCodeDiscount / 100)).toFixed(2);
            }

        },
        data() {
            return {
                amountKassas: 1,
                deleteKassaRequirementIsOpened: false,
                promoCode: null,
                promoCodeId: null,
                promoCodeDiscount: 0,
                promoCodeIsActive: false,
            }
        },
        methods: {
            async checkPromoCode() {
                if (this.promoCodeIsActive) return;
                const result = await this.$store.dispatch("fetchPromoCode", this.promoCode);
                if (result.successfully) {
                    this.promoCodeId = result.data.id;
                    this.promoCodeDiscount = result.data.discount;
                    this.promoCodeIsActive = true;
                }
            },
            handlePromoCodeInput(event) {
                this.promoCodeId = null;
                this.promoCodeDiscount = 0;
                this.promoCodeIsActive = false;
                event.target.value = event.target.value.toUpperCase().slice(0, 10);
            },
            async selectPlan() {
                if (this.amountKassas < this.kassas.length) {
                    document.body.classList.add("overflow-hidden");
                    this.deleteKassaRequirementIsOpened = true;
                    return;
                }
                if (this.name !== "free") {
                    this.$store.dispatch("payPlan", {amount_shops: this.amountKassas, name: this.name, promoCodeId: this.promoCodeId})
                    this.$notify("Перенаправляем на страницу оплаты...", 3000);
                } else {
                    const result = await this.$store.dispatch("goToFreePlan");
                    if (result.successfully) {
                        this.$notify("Вы успешно переведены на бесплатный тариф!")
                    }
                }
            },
            handleInputAmountKassas() {
                if (!this.amountKassas || this.amountKassas < 1) {
                    this.amountKassas = 1;
                }
            },
            initData() {
                if (this.isActive) {
                    this.amountKassas = this.currentAmountOfShops;
                }
            },
        },
        mounted() {
            this.initData();
        }
    }
</script>   